import { Link } from "react-router-dom";

const DOCTOR_REQUEST_AVAILABLE = true;

export function Header({ onStageCheck, homepage = false }) {
  const stageHref = homepage ? "#check" : "/#check";

  return (
    <header className="sticky-nav homepage-header fixed top-0 left-0 right-0 z-50" data-testid="site-header">
      <div className="homepage-header__inner max-w-6xl mx-auto px-5 sm:px-8 flex items-center justify-between">
        <Link to="/" className="homepage-header__logo flex items-center" data-testid="header-logo-link">
          <img src="/brand/supple-logo-transparent.png" alt="Supple" data-testid="header-logo-img" />
        </Link>
        <nav className="homepage-header__nav" aria-label="Main navigation">
          <Link to="/supplement-check" className="homepage-header__desktop-link" data-testid="header-supplements-link">Supplements</Link>
          {DOCTOR_REQUEST_AVAILABLE && <Link to="/doctor-request" className="homepage-header__desktop-link" data-testid="header-doctor-link">Talk to a doctor</Link>}
          <a href={stageHref} onClick={homepage ? onStageCheck : undefined} className="homepage-header__action" data-testid="header-check-stage-button">Check my stage</a>
        </nav>
      </div>
    </header>
  );
}